import { COLORS, RADIUS, SHADOWS } from "../../theme";

export const Style = {
  wrapper: {
    background: { xs: COLORS.dark, sm: "none" },
    boxSizing: "border-box",
    display: "flex",
    flexWrap: "noWrap",
    overflow: "auto",
    top: "0 !important",
  },
  main: (isEmployee) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: { xs: "600px", sm: "400px" },
    bgcolor: isEmployee ? 'rgba(0, 0, 0, 0)' : { xs: "none", sm: COLORS.dark },
    color: COLORS.white,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    boxShadow: SHADOWS.modal,
    gap: "10px",
    borderRadius: RADIUS.modal,
    border: "1px solid rgba(255,255,255,0.08)",
    p: { xs: 2, sm: 4 },
    boxSizing: "border-box",
    height: { xs: "100%", sm: "auto" },
    outline: isEmployee && 'none',
    // outline: isEmployee ? 'none' : 'auto'
  }),
  actionBtn: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
    display: { xs: "none", sm: "flex" },
    alignSelf: "flex-end",
  },
};
